import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
export var DialogMaintenance = function () {
    var onButtonClick = function () {
        return window.open(utilLoca.get(IdLoca.settingsMenu_facebook_url), "_blank");
    };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.alert_serverDowntime_title, className: IdStyles.ModalBackground },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.alert_serverDowntime_desc }),
            React.createElement("div", { className: "button-ribbon" },
                React.createElement(ButtonPrimary, { onClick: onButtonClick },
                    React.createElement("div", { className: IdStyles.TextBoldAccent },
                        React.createElement(TextLoca, { id: IdLoca.showMore })))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/client-gateway/DialogMaintenance.tsx
// module id = 2554
// module chunks = 3